import { t } from "i18next";
import React, { useState } from "react";
import { useSettings } from "../../context/SettingsContext";
import logobottom from "../../assets/image/logo-bottom-new.png";

interface FeedBackUserProps {
  setIsFeedbackActive: (active: boolean) => void;
}

const FeedBackUser: React.FC<FeedBackUserProps> = ({
  setIsFeedbackActive,
}) => {
  const { widgetButtonColor, widgetButtonTextColor } = useSettings();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const recipient = "support@user-aid.com";
    const subject = "Feedback from Widget";
    const body = `Sender Email: ${email}\n\nIssue Description:\n${message}`;
    const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  return (
    <>
      <div className="flex w-full h-full items-center bg-gray-100">
        <div className="w-full bg-white p-6 mt-12 rounded-lg shadow-lg">
          <div className="text-center mb-1 justify-center items-center flex">
            <img
              src={logobottom}
              alt="Logo"
              className="object-contain justify-center items-center   w-[37%]  h-auto"
            />
          </div>
          <div className="text-center mb-4">
            {/* <p className="text-sm text-gray-500">A Level Access company</p> */}
          </div>
          <form className="flex flex-col items-center">
            <div className="w-full max-w-md">
              <div className="mb-4">
                <input
                  type="email"
                  placeholder={t("please_enter_your_email")}
                  className="w-full h-12 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="mb-4">
                <textarea
                  placeholder={t("please_describe_our_issue")}
                  className="w-full h-[221px] px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
            </div>

            {/* Keep the button section unchanged */}
            <div className="flex justify-end w-full max-w-md mt-4 mb-2">
              <button
                className="w-1/4 text-white py-2 rounded-md"
                style={{
                  background: widgetButtonColor,
                  //color: widgetButtonTextColor,
                }}
                onClick={handleSubmit}
              >
                {t("send")}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="fixed right-0  bottom-4 text-white rounded-full p-4 cursor-pointer">
        <img
          src={logobottom}
          alt="Logo"
          className="object-contain float-right w-[37%] pr-3 h-auto"
        />
      </div>
    </>
  );
};

export default FeedBackUser;
